import React, { useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import purifyHTML from '../../../utils/purify-html';
import {
  validateCanvaEmbedCode,
  validateCanvaUrl,
} from '../../../utils/validate-canva';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import {
    Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';

import { addWidget, addContent } from '../../../redux/actions/Content';
import { FileDropzone } from '../../../components/addcontent/FileDropzone';
import { api } from 'src/api/endpoints';
import Lightbox from 'yet-another-react-lightbox';
import CloseIcon from '@mui/icons-material/Close';

export default function DialogBoxCanva({
  isOpen,
  onClose,
  onAddWidget,
  onAddContent,
  isIcon,
  startupData,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentFolder } = useSelector((state) => state.FileFolder);
  const { user } = useSelector((state) => state.User);

  //Form fields
  const [name, setName] = useState('');
  const [embedCode, setEmbedCode] = useState('');
  const [file, setFile] = useState(null);
  const [liveURL, setLiveURL] = useState('');

  const [addStep, setAddStep] = useState(0)
  const [altImgUrl, setAltImgUrl] = useState('')
  const [openCanvaAltPreview, setOpenCanvaAltPreview] = useState({open: false, url: ""})

  const [currentWay, setCurrentWay] = useState('url');

  useEffect(() => {
    // handleDialogClose();
    if (startupData) {
      setName(startupData.name);
      if (startupData.widget?.newLink) {
        setLiveURL(startupData.widget?.newLink);
        setCurrentWay('url');
      }
      if (startupData.widget?.newEmbed) {
        setEmbedCode(startupData.widget?.newEmbed);
        setCurrentWay('embed');
      }
    }
  }, [isOpen]);

  const handleFileDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
  }, []);

  const handleRemoveFile = useCallback(() => {
    setFile(null);
  }, []);

  const handleDialogClose = useCallback(() => {
    setName('');
    setEmbedCode('');
    setFile(null);
    setLiveURL('');
    setCurrentWay('url');
    setOpenCanvaAltPreview({open: false, url: ""})
    setAltImgUrl('')
    setAddStep(0)
  }, []);

  const handleAdd = useCallback(async () => {
    const isEmbed = !!currentWay == 'embed';

    // Validate required fields
    if (name === '' || (!file && !embedCode && !liveURL)) {
      toast.error(t('views.dialogBoxCanva.fillRequiredFields'));
      return;
    }

    // Validate embed code or URL
    if (isEmbed && embedCode) {
      const embedValidation = validateCanvaEmbedCode(embedCode);
      if (!embedValidation.isValid) {
        toast.error(embedValidation.error);
        return;
      }
    } else if (liveURL) {
      const urlValidation = validateCanvaUrl(liveURL);
      if (!urlValidation.isValid) {
        toast.error(urlValidation.error);
        return;
      }
    }

    let action;

    if (currentWay == 'embed') {
      action = onAddWidget({
        name,
        type: 'widget',
        widgetCat: 'canva',
        widgetIcon: isIcon,
        url: '',
        html: embedCode,
        folderId: currentFolder,
        user: user._id,
        newLink: '',
        newEmbed: embedCode,
      });
    } else if (currentWay == 'url') {
      console.log(liveURL);
      action = onAddWidget({
        name,
        type: 'widget',
        widgetCat: 'canva',
        widgetIcon: isIcon,
        url: liveURL,
        html: '',
        folderId: currentFolder,
        user: user._id,
        newEmbed: '',
        newLink: liveURL,
      });
    }

    // if (isEmbed) {
    //   // Sanitize the HTML to allow only valid Canva iframes
    //   let embedHTML = purifyHTML.sanitize(embedCode, { ADD_TAGS: ['iframe'] });

    //   // Remove any localhost:3000 or other local development URLs that might have been prepended
    //   embedHTML = embedHTML.replace(
    //     /https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\/+/gi,
    //     '',
    //   );

    //   // Escape quotes and newlines for storage
    //   embedHTML = embedHTML
    //     .replaceAll(/"/g, '\\"')
    //     .replaceAll(/\n/g, '\\n')
    //     .toString();

    //   action = onAddWidget({
    //     name,
    //     type: 'widget',
    //     widgetCat: 'canva',
    //     widgetIcon: isIcon,
    //     url: '',
    //     html: embedHTML,
    //     folderId: currentFolder,
    //     user: user._id,
    //   });
    // } else {
    //   //Handle file
    //   // const form = new FormData();
    //   // form.append("content", file);
    //   // form.append("user", user.isMember ? user?.user._id : user._id);
    //   // form.append("subuser", user.isMember ? user?.user._id : user._id);
    //   // form.append("role", user.isMember ? user?.role.split("-")[0] : user?.role);
    //   // form.append("folderId", currentFolder);

    //   action = onAddContent({
    //     preventDefault: () => {},
    //     target: {
    //       files: [file],
    //     },
    //   });
    // }

    const result = await action;

    // console.log(result)

    if (currentWay == 'url') {
        setAddStep(1)

        try {
            const { data, status } = await api.post('/content/canva2img', {
                url: liveURL,
                contentId: result?.id
            })
            setAltImgUrl(data?.uri)
            setAddStep(2)
        } catch (err) {
            setAltImgUrl('ERROR')
            setAddStep(2)
        }
    }else {
        handleDialogClose()
        onClose();
    }

    // result.then((data) => {
    //     console.log(data)
    // })
  }, [
    name,
    embedCode,
    file,
    liveURL,
    currentWay,
    currentFolder,
    dispatch,
    isIcon,
    onClose,
    t,
    user,
  ]);

  return (
    <>
      <Dialog fullWidth open={isOpen} onClose={() => {
                onClose(false)
                handleDialogClose()
                }}>
        <Box display='flex' alignItems='center' justifyContent='center' mt={2}>
          <img src={'./images/canvaLogo.svg'} alt='Logo' width={'150px'} />
        </Box>
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
          {addStep == 0 ? t('views.dialogBoxCanva.title') : name}
        </DialogTitle>
        <DialogContent sx={{ minHeight: '30vh' }}>
          <Grid container spacing={2}>
            {addStep == 0 && (
                <Grid item xs={12} mt={2}>
                <Button
                    href='https://www.canva.com/'
                    target='_blank'
                    variant='contained'
                    color='primary'
                    underline='none'
                >
                    {t('views.dialogBoxCanva.loginToCanva')}
                </Button>
                </Grid>
            )}
            <Grid item xs={12} mt={2}>
                {addStep == 0 && (
                    <TextField
                      label={t('views.dialogBoxCanva.canvaDesignName')}
                      fullWidth
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                )}
            </Grid>
            {addStep == 0 && (
                <>
                    <Tabs
                    sx={{
                        p: 3,
                    }}
                    value={currentWay}
                    onChange={(e, newValue) => {
                        setCurrentWay(newValue);
                    }}
                    aria-label='basic tabs example'
                    >
                    {/* <Tab label='Embed code' value={'embed'} /> */}
                    <Tab label='Live Link' value={'url'} />
                    </Tabs>
                    {currentWay == 'embed' && (
                    <Grid item xs={12}>
                        <Typography variant='h6'>
                        {t('views.dialogBoxCanva.addCanvaAsEmbedCode')}
                        </Typography>
                        <Box display='flex' alignItems='center' mt={3}>
                        <TextField
                            variant='outlined'
                            multiline
                            label={t('views.dialogBoxCanva.canvaDesignEmbedCode')}
                            fullWidth
                            value={embedCode}
                            rows={5}
                            onChange={(e) => setEmbedCode(e.target.value)}
                        />
                        </Box>
                        <Typography align='right' mt={2}>
                        <Link
                            href='https://www.canva.com/help/embed-designs/'
                            target='_blank'
                        >
                            {t('views.dialogBoxCanva.howToGetEmbedCode')}
                        </Link>
                        </Typography>
                    </Grid>
                    )}
                    {currentWay == 'url' && (
                    <Grid item xs={12}>
                        <Typography variant='h6'>Add canva using URL link</Typography>
                        <Box display='flex' alignItems='center' mt={3}>
                        <TextField
                            variant='outlined'
                            label={'Public live URL'}
                            fullWidth
                            value={liveURL}
                            rows={5}
                            placeholder='https://www.canva.com/...'
                            onChange={(e) => setLiveURL(e.target.value)}
                        />
                        </Box>
                    </Grid>
                    )}
                    {/* {!startupData ? (
                    <Grid item xs={12}>
                        <Typography variant="h6">{t("views.dialogBoxCanva.orUploadCanvaFile")}</Typography>
                        <Box mt={4} display="flex">
                        <FileDropzone
                            accept={{
                            "image/jpeg": [],
                            "image/png": [],
                            "image/webp": [],
                            "image/heic": [],
                            "image/jfif": [],
                            }}
                            caption={t("views.dialogBoxCanva.maxFileSize")}
                            files={[file].filter(Boolean)}
                            disabled={!!embedCode}
                            onDrop={handleFileDrop}
                            onRemove={handleRemoveFile}
                            onRemoveAll={handleRemoveFile}
                            onUpload={() => { }}
                            multiple={false}
                            maxFiles={1}
                        />
                        </Box>
                    </Grid>
                    ) : null} */}
                        </>
                    )}
                    {(addStep == 1 || addStep == 2) && (
                        <>
                            <Box sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                height: "200px",
                                flexDirection: "column",
                                mt: 3
                            }}>
                                {addStep == 1 && (
                                    <CircularProgress/>
                                )}
                                {(addStep == 2 && altImgUrl == 'ERROR') && (
                                    <>
                                        <Typography variant='subtitle1' textAlign={"center"} color={"warning.main"}>An error occured</Typography>
                                        <Typography variant='subtitle2' textAlign={"center"} color={"warning.main"} sx={{
                                            mt:2
                                        }}>Failed to create alternative image</Typography>
                                    </>
                                )}
                                {(addStep == 2 && altImgUrl !== 'ERROR') && (
                                    <>
                                        <img src={altImgUrl} alt="" role="button" style={{
                                            width: "100%",
                                            maxWidth: "400px",
                                            height: "100%",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                            borderRadius: "15px"
                                        }} onClick={() => setOpenCanvaAltPreview({
                                            open: true,
                                            url: altImgUrl
                                        })} />
                                    </>
                                )}
                            </Box>
                        </>
                    )}
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: 2,
            marginTop: 1,
          }}
        >
          <div style={{ marginLeft: 'auto' }}>
            <Button onClick={() => {
                onClose(false)
                handleDialogClose()
                }}>
              {addStep == 1 ? (
                t('views.dialogBoxCanva.cancel')
              ) : (
                "Close"
              )}
            </Button>
            {addStep == 0 && (
                <Button variant='contained' color='primary' onClick={handleAdd}>
                {t('views.dialogBoxCanva.save')}
                </Button>
            )}
          </div>
        </DialogActions>
      <Backdrop open={openCanvaAltPreview.open} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, display: "flex", flexDirection: "column" })}>
        <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            width: "80%"
        }}>
            {/* <div></div>
            <Typography variant='caption'>Preview</Typography> */}
            <IconButton color="primary" onClick={() => setOpenCanvaAltPreview((prev) => {
                return {...prev, open: false, url: ''}
            })}>
                <CloseIcon />
            </IconButton>
        </Box>
        <img src={openCanvaAltPreview.url} alt="" style={{
            width: "80%",
            height: "80%",
            objectFit: "contain"
        }} />
      </Backdrop>        
      </Dialog>
      {/* <Lightbox open={openCanvaAltPreview.open} close={() => setOpenCanvaAltPreview((prev) => {
        return {...prev, open: false, url: ''}
      })} slides={[
        {src: openCanvaAltPreview.url}
      ]} /> */}
    </>
  );
}
